import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layerMain" }
const _hoisted_2 = { class: "layerMainText" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "bold red" }
const _hoisted_5 = { class: "layerBtnArea" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "layer deletAlt",
    style: _normalizeStyle({top : $props.top+'px', left : $props.left+'px'})
  }, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "layerTitle" }, "코인부족 안내", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", { innerHTML: $props.message }, null, 8, _hoisted_3),
        _createElementVNode("span", _hoisted_4, "필요 코인 : " + _toDisplayString($props.coin.toComma()) + " 코인 ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "redBtn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.Coin_Charge()))
      }, "코인충전"),
      _cache[2] || (_cache[2] = _createTextVNode("  ", -1)),
      _createElementVNode("button", {
        class: "grayBtn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.is_view=false))
      }, "취소")
    ])
  ], 4)), [
    [_vShow, $data.is_view]
  ])
}